import { render } from "./sales-invoice.vue?vue&type=template&id=687dae2e&scoped=true"
import script from "./sales-invoice.vue?vue&type=script&lang=js"
export * from "./sales-invoice.vue?vue&type=script&lang=js"

import "./sales-invoice.vue?vue&type=style&index=0&id=687dae2e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687dae2e"]])

export default __exports__